import React, { memo } from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

const UiNotificationCheckbox = memo((props) => {
  const { label, inputProps, checked, onChange, name } = props;
  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Checkbox
            id={props.id}
            checked={checked}
            onChange={onChange}
            name={name}
            {...inputProps}
          />
        }
        label={label}
      />
    </FormGroup>
  );
});

export default UiNotificationCheckbox;
